var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4074 16.0066L21 21.5652M17.9514 9.98934C17.9514 14.6419 14.1567 18.4135 9.47568 18.4135C4.79469 18.4135 1 14.6419 1 9.98934C1 5.33681 4.79469 1.56519 9.47568 1.56519C14.1567 1.56519 17.9514 5.33681 17.9514 9.98934Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseBot);
export default __webpack_public_path__ + "static/media/database-bot.fb4a34a15618885cfb00e26dcb1033ac.svg";
export { ForwardRef as ReactComponent };